









import { Component, Vue } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import * as t from '@/types'

@Component
export default class Header extends Vue {
  @Getter annualIncome!: number
  @Getter annualExpenses!: number

  get incomeString () { return `${t.currencySymbol}${this.annualIncome} Income` }
  get expensesString () { return `${t.currencySymbol}${this.annualExpenses} Expenditure` }

  get progressBarStyle () {
    const divisor = Math.max(1, this.annualIncome + this.annualExpenses)
    const percentage = 100 * this.annualExpenses / divisor
    return { width: `${percentage}%` }
  }
}
